import { makeVar } from '@apollo/client';

export const conventionNameVar = makeVar('');
export const conventionCurrencyCodeVar = makeVar('');
export const editCoefficientVar = makeVar({ open: false, coefficient: {} });
